import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { TaskHistory } from '@workspaces/models/task';
import { Observable } from 'rxjs';
import { TaskHistoryDisplayPipe } from './task-history-message.pipe';
import { AppState } from 'src/app/state/app.state';
import { Store } from '@ngrx/store';

import { taskHistoryFeature, TaskHistoryFetch } from '@workspaces/store/task-history.feature';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ShortIdPipe } from '../../utils/pipes/short-id.pipe';

@Component({
  selector: 'app-task-history',
  templateUrl: './task-history.component.html',
  styleUrls: ['./task-history.component.scss'],
  standalone: true,
  imports: [CommonModule, TaskHistoryDisplayPipe, MatProgressBar, ShortIdPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskHistoryComponent implements OnInit {
  @Input({ required: true }) workspaceId!: string;
  @Input({ required: true }) taskId!: string;

  constructor(private readonly store: Store<AppState>) {}
  public taskHistory$!: Observable<TaskHistory[]>;
  public taskHistoryIsLoading$!: Observable<boolean>;
  ngOnInit() {
    this.taskHistory$ = this.store.select(taskHistoryFeature.taskHistoryData(this.taskId));
    this.taskHistoryIsLoading$ = this.store.select(taskHistoryFeature.taskHistoryIsLoading(this.taskId));

    this.store.dispatch(TaskHistoryFetch({ workspaceId: this.workspaceId, taskId: this.taskId }));
  }
}
